import * as React from 'react';
import { shape, bool } from 'prop-types';
export const Error = ({ error, debug }) => {
    return (React.createElement("div", { id: "root__error", className: "container" },
        React.createElement("div", { className: "grid isBound" },
            React.createElement("div", { className: "col__12-12" },
                React.createElement("div", { className: "grid error-page", "data-testid": "errorContent" },
                    React.createElement("div", { className: "grid grid isBound error-page" },
                        React.createElement("div", { className: "error-page__container col__12-12" },
                            React.createElement("img", { src: "https://assets.homedepot-static.com/images/v1/oops.svg", alt: "", className: "error-page__image", width: "702", height: "205" }),
                            React.createElement("h1", { className: "error-page__title u__display-font--black" }, "WE'RE FIXING IT."),
                            React.createElement("div", { className: "error-page__description" },
                                React.createElement("p", null, "We'll have this patched up as soon as possible.")),
                            error && debug && (React.createElement("pre", null,
                                React.createElement("code", null, error.stack))),
                            React.createElement("div", { className: "error-page__buttons" },
                                React.createElement("a", { className: "bttn bttn--primary bttn--inline u__bottom--standard body__m-right-large", href: "/" },
                                    React.createElement("span", { className: "bttn__content" }, "Back to homepage"))))))))));
};
Error.propTypes = {
    error: shape({}),
    debug: bool,
};
Error.defaultProps = {
    error: null,
    debug: false,
};
